import React from "react";
import { Box, useTheme } from "@mui/material";
import { getTeamColor } from "../../config/theme";

interface TeamBadgeProps {
  team: string;
  /** sm = compact table cell, md = default. */
  size?: "sm" | "md";
}

/**
 * NFL team badge — colored rounded square with the abbreviation, dark-mode aware.
 * Single source for the previously-duplicated per-file team badges.
 */
export default function TeamBadge({ team, size = "md" }: TeamBadgeProps) {
  const { palette } = useTheme();
  const isDark = palette.mode === "dark";
  // No team abbreviation (e.g. a DraftKings import without team data) → render
  // nothing rather than an empty colored square.
  if (!team || !team.trim()) return null;
  const bg = getTeamColor(team, isDark, "bg");
  const height = size === "sm" ? 22 : 24;
  return (
    <Box
      component="span"
      title={team}
      aria-label={team}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: size === "sm" ? 30 : 34,
        height,
        px: 0.5,
        borderRadius: "4px",
        bgcolor: bg,
        color: "#fff",
        fontWeight: 700,
        fontSize: size === "sm" ? 9 : 11,
        letterSpacing: "-0.3px",
        flexShrink: 0,
      }}
    >
      {team.slice(0, 3)}
    </Box>
  );
}
